import React, {PropTypes as T} from 'react';
import QunatitySelector from '../../../common/quantity_selector';
import basketActions from '../../../../actions/basket';
import InfoIcon from '../../../common/icons/icon_info';
import Tooltip from '../../../common/tooltip';
import TU from '../../../common/tu';
import {getDataAttributeSelectorString, priceTypeToSlug} from '../../../../utils/pricetype/pricetype_utils';
import OmnitureBuilder from '../../../../utils/omniture-helper/omniture_builder';
import {
  getPriceWithMandatoryUpsellsFormatted,
  mandatoryUpsellsString
} from '../../pricetypeselector/pricetype/utils';
import translate from '../../../../utils/translate';
import FEE_ROLLUP from '../../basket/recap/feerollup_states';
import {sprintf} from 'sprintf-js';
export default class GANormalPriceType extends React.Component {
  static propTypes = {
    totalQuantityInSelection: T.number,
    totalQuantityInSection:   T.number,
    quantityInSelection:      T.number,
    ticketsInBasket:          T.number,
    ticketLimit:              T.number,
    categoryId:               T.string,
    categoryAvailability:     T.number,
    priceType:                T.object,
    price:                    T.object,
    moneyFormat:              T.string,
    currency:                 T.string,
    mandatoryUpsells:         T.array,
    feeRollup:                T.string
  };

  onChange = (newValue) => {
    basketActions.updateGASectionTicketQuantity(
      this.props.categoryId,
      this.props.priceType.number.toString(),
      parseInt(newValue)
    );
  };

  showInfoIcon = (priceType, price) => {
    return priceType.name &&
    priceType.additionalInfo &&
    priceType.additionalInfo.length > 0 ||
    priceType.name &&
    price.priceInfo;
  };

  makeTooltipSelector = (priceType) => {
    const selector = priceTypeToSlug(priceType) + this.props.categoryId;
    return getDataAttributeSelectorString('selector', selector);
  };

  onInfoIconClick = () => {
    OmnitureBuilder.tmLinksNavlink('AdditionalInfo').sendSingle();
  };

  renderAdditionalInfo = (priceType, price) => {
    let additionalInfoAndPriceComponents = [];

    priceType.additionalInfo.forEach(function (a)  {
      this.push(a);
    }, additionalInfoAndPriceComponents);

    if (price.priceInfo) {
      additionalInfoAndPriceComponents.push(price.priceInfo);
    }

    return additionalInfoAndPriceComponents.map((section, index) => {
      if (section.content.length > 0) {
        return (<div className="tooltip__content" key={index}>
          <div className="tooltip__contentheader">
            <TU text={section.title} />
          </div>
          <div className="tooltip__contentbody">
            <TU text={section.content} />
          </div>
        </div>);
      }
      else {
        return false;
      }
    });
  };

  render () {
    const {
      priceType,
      ticketLimit,
      ticketsInBasket,
      totalQuantityInSelection,
      totalQuantityInSection,
      quantityInSelection,
      price,
      moneyFormat,
      currency,
      mandatoryUpsells,
      feeRollup,
      categoryAvailability
    } = this.props;

    const minTicketLimit = categoryAvailability === undefined
      ? ticketLimit
      : Math.min(categoryAvailability, ticketLimit);
    const ticketsLeft = ticketLimit - ticketsInBasket;
    const ticketsLeftInSection = minTicketLimit - totalQuantityInSection;
    const max = ticketsLeft >= ticketsLeftInSection
      ? (ticketsLeftInSection - totalQuantityInSelection) + quantityInSelection
      : (ticketsLeft - totalQuantityInSelection) + quantityInSelection;
    const priceWithMandatoryUpsellsFormatted = getPriceWithMandatoryUpsellsFormatted(this.props);

    let feeMessage = '';
    if (feeRollup !== FEE_ROLLUP.ROLLUP_SHOW_BREAKDOWN) {
      feeMessage = '';
    }
    else {
      const text = {
        ticketServiceFee: translate('ticketPriceInformationModule', 'TICKET_SERVICE_FEE'),
        serviceFeePrefix: translate('ticketPriceInformationModule', 'SERVICE_FEE_RANGE_PREFIX'),
        serviceFeeSuffix: translate('ticketPriceInformationModule', 'SERVICE_FEE_RANGE_SUFFIX'),
        and:              translate('eventInfoModule', 'AND'),
        currency:         currency
      };
      // format included charges (service fee)
      const maxTotal = price.includedCharge / 100;
      const decimalsMax = Math.round((maxTotal % 1) * 100);
      const sFString = sprintf(moneyFormat, maxTotal, decimalsMax, text.currency);
      // Generate service fee mesaage with text unit
      const serviceFeeMessage = translate('eventInfoModule', 'FEE_INCLUDED', {'%TICKET_FEE%': sFString});
      const mandatoryUpsellsStringMessage = mandatoryUpsellsString(this.props.price.priceType, mandatoryUpsells, text);
      // if no positive charges and no mandatory upsells than  set fee mesage to ''
      if (price.includedCharge === 0 && mandatoryUpsellsStringMessage === '') {
        feeMessage = '';
      }
      else {
        feeMessage = `(${serviceFeeMessage}${mandatoryUpsellsStringMessage})`;
      }
    }
    return (
      <div className="ismmodal__option" data-component="gapricetype">
        <div className="ismmodal__option__label">
          <div className="ismmodal__option__label__title_container">
            <h3
              className="ismmodal__option__label__title"
              data-component="gapricetype-title">{priceType.name}</h3>
            {this.showInfoIcon(priceType, price) &&
            <a
              data-selector={priceTypeToSlug(priceType) + this.props.categoryId}
              data-component="info-icon"
              className="ismmodal__option__additional_info_icon"
              tabIndex="0"
              role="button"
              onClick={this.onInfoIconClick}>
              <InfoIcon width={22} height={22} />
            </a>}
            {this.showInfoIcon(priceType, price) && <Tooltip selector={this.makeTooltipSelector(priceType)} >
              <div>
                {this.renderAdditionalInfo(priceType, price)}
              </div>
            </Tooltip>}
          </div>
          <p
            className="ismmodal__option__label__price"
            data-component="gapricetype-price">{priceWithMandatoryUpsellsFormatted}</p>
          <span className="ismmodal__option__label__info" data-component="ismmodal_pricetype_feerollup">{feeMessage}</span>
        </div>
        <div className="ismmodal__option__control">
          <QunatitySelector
            quantity={quantityInSelection}
            max={max}
            onChange={this.onChange}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/edp/generaladmission/gapricetype/normal_pricetype.js